

import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { Getter } from "vuex-class"
import { Team } from "@/types"
import vSelect from "vue-select"
import { TenantFeatures } from "@/types/tenantFeatures"

@Component({
	components: {
		"v-select": vSelect
	}
})
export default class SelectableFormControl extends Vue {
	@Prop()
	value!: any

	@Prop({ default: false })
	readonly!: boolean

	@Prop({ default: () => [] })
	defaultValue!: any

	@Prop({ default: "" })
	label!: string

	get enabled (): boolean {
		return this.value !== null && this.value !== undefined
	}
	set enabled (value: boolean) {
		this.$emit("input", value ? (this.value ? this.value : this.defaultValue) : null)
	}

	updateValue (newValue: any) {
		this.$emit("input", newValue)
	}
}

